// extracted by mini-css-extract-plugin
export default {"root":"ReactPortalSubstrate_root__wEkdD"};